{
  "id": "forseti",
  "pantheon": "norse",
  "name": {
    "pt-BR": "Forseti",
    "en": "Forseti"
  },
  "icon": "gods/forseti",
  "portrait": "gods/forseti-portrait",
  "age": "classical",
  "freeUnitsOnAgeUp": {
    "troll": 1
  },
  "unlocks": [
    "troll",
    "hall-of-thanes",
    "dwarven-breastplate",
    "dwarven-breastplate-thor",
    "cave-troll"
  ],
  "powers": ["healing-spring"],
  "meta": {
    "source": "Game files 19.17020 (techtree.xml)",
    "checkedAt": "2026-10-18",
    "confidence": "high",
    "note": "Thor, Loki. Focus: infantry. Age tech ClassicalAgeForseti."
  },
  "fieldMeta": {
    "freeUnitsOnAgeUp": {
      "source": "Game files 19.17020 (techtree.xml)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "ClassicalAgeForseti: CreateUnit troll quantity 1, generator AbstractTemple (spawns at a Temple)."
    }
  }
}
